<template>
  <div>
    <a-form class="form" :form="form" @submit.prevent="handleSubmit">
      <p class="error" v-if="error">{{ error }}</p>
      <email-input v-model="email" />
      <password-input v-model="password" :validation="false" class="password-input" />
      <login-actions :email="emailWrongPassword" />
      <a-button :disabled="disabled" :loading="loading" type="primary" html-type="submit">
        {{
        $t('submit')
        }}
      </a-button>
    </a-form>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import EmailInput from '@/components/common/EmailInput.vue';
import PasswordInput from '@/components/common/PasswordInput.vue';

import { SIGN_IN } from '@/store/session/actionTypes';

import { FIREBASE_ERRORS } from '@/constants';

import LoginActions from './LoginActions.vue';

export default {
  components: {
    EmailInput,
    PasswordInput,
    LoginActions,
  },
  data() {
    return {
      email: '',
      password: '',
      loading: false,
      error: '',
      disabled: true,
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'login' });
  },
  provide() {
    return {
      form: this.form,
    };
  },
  computed: {
    emailWrongPassword() {
      return this.error.code === FIREBASE_ERRORS.WRONG_PASS ? this.email : '';
    },
  },
  methods: {
    ...mapActions({
      signIn: SIGN_IN,
    }),
    async handleSubmit() {
      const { email, password } = this;

      this.loading = true;

      try {
        await this.signIn({ email, password });
        this.$emit('success');
      } catch (error) {
        this.error =
          error.code === FIREBASE_ERRORS.WRONG_PASS || FIREBASE_ERRORS.USER_NOT_FOUND
            ? this.$t('user.not.found.error')
            : error.message;
      } finally {
        this.loading = false;
      }
    },
    setSubmitDisable() {
      this.form.validateFields((err) => {
        if (!err) {
          this.disabled = false;
        } else {
          this.disabled = true;
        }
      });
    },
  },
  watch: {
    email() {
      this.setSubmitDisable();
    },
    password() {
      this.setSubmitDisable();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/colors.scss';
.form {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.error {
  color: $red;
  font-size: 15px;
  padding-bottom: 15px;
  text-align: center;
}
.password-input {
  width: 100%;
}
</style>
